export default __webpack_public_path__ + "static/media/atsumi.797d39ab.png";